<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th class="text-center"><v-icon small class="mr-1" color="blue">mdi-wrench-outline</v-icon> <ReportStatusListHover title="Fontes Pendentes" :reports="bioscan.pxdata.summary.pending_report_list"></ReportStatusListHover></th>
        <th class="text-center"><v-icon small class="mr-1" color="green">mdi-check-circle-outline</v-icon> <ReportStatusListHover title="Fontes Consultadas" :reports="bioscan.pxdata.summary.finished_report_list"></ReportStatusListHover></th>
        <th class="text-center"><v-icon small class="mr-1" color="red">mdi-alert-circle-outline</v-icon> <ReportStatusListHover title="Fontes com Erro" :reports="bioscan.pxdata.summary.failed_report_list"></ReportStatusListHover></th>
        <th class="text-center"><v-icon small class="mr-1" color="yellow">mdi-cash-usd</v-icon> <ReportStatusListHover title="Fontes Opcionais" :reports="bioscan.pxdata.summary.optional_report_list"></ReportStatusListHover></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th class="text-center">
          {{ bioscan.pxdata.summary.pending_report_list.length }}
        </th>
        <th class="text-center">
          {{ bioscan.pxdata.summary.finished_report_list.length }}
        </th>
        <th class="text-center">
          <v-btn small text outlined
            v-if="bioscan.pxdata.summary.failed_report_list.length"
            @click="retryFailedReports"
          >
            {{ bioscan.pxdata.summary.failed_report_list.length }}: Tentar Novamente
          </v-btn>
          <span v-else>{{ bioscan.pxdata.summary.failed_report_list.length }}</span>
        </th>
        <th class="text-center">
          {{ bioscan.pxdata.summary.optional_report_list.length }}
        </th>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import ReportStatusListHover from './ReportStatusListHover'

export default {
  components: {
    ReportStatusListHover,
  },

  props: {
    bioscan: Object,
  },

  methods: {
    retryFailedReports: async function() {
      await this.$store.dispatch('bioscans/retry_failed_reports_bioscan', this.bioscan.id)
      this.$emit('summaryChanged')
    },
  },
};
</script>
